module.exports = __webpack_public_path__ + "static/media/IMAGE-3-DEFORESTATION-desktop.cbb3a55e.jpg";